/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.programs.detail.chart.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.calendar',
  'acme.common.service.ganttTransform'
])

.controller('ProgramsDetailChartController', ['$scope', '$state', '$filter', '$timeout', 'ResolveViewData', 'ApiService', 'CalendarService', 'GanttTransformService', function($scope, $state, $filter, $timeout, ResolveViewData, ApiService, CalendarService, GanttTransformService) {
    var resizeTimer;

    $scope.programsDetailChart = {

      chart: {},

      model: { data: [] },
      ganttRefresh: false,
      startTime: '',
      endTime: '',
      isEmpty: false,

      init: function() {

        this.startTime = CalendarService.toISO8601(new Date());
        this.endTime =  CalendarService.toISO8601(new Date().setDate((new Date()).getDate() + 1));
        this.chart = $('#programs-detail-chart-gantt');

        console.log('EntitiesDetailChartController::init', $state.params);
        if ($state.params && $state.params.id) {
          this.getEvents($state.params.id);
        }

        $scope.$emit('AppController::updateTitle', {
          title: 'Schedule'
        });

        $scope.$on('$destroy', this.onDestroy);

//        $(window).on('resize', this.onWindowResize);

      },

      showEmpty: function() {
        this.isEmpty = true;
      },

      showChart: function() {
        this.isEmpty = false;
      },

      getEvents: function(id) {
        ApiService.event.schedules({
          templateId: id,
          startTime: this.startTime,
          endTime: this.endTime
        }).then(this.success.getEvents, this.error.getEvents);
      },

      getDuration: function(startDate, endDate) {
        var diff = endDate.getTime() - startDate.getTime(),
          minutes = 1000 * 60;

        return diff / minutes;

      },

      success: {

        getEvents: function(response) {

            var eventList = response.data.payload;

            for (var i = 0; i < eventList.length; i++) {
                var te = GanttTransformService.event(eventList[i], false);
                $scope.programsDetailChart.model.data.push(te.event);
            }

            $scope.programsDetailChart.ganttRefresh = 'hard';

            $scope.$apply(function() {});
        }

      },

      error: {},

      onDestroy: function() {
        $(window).off('resize');
      },

      onWindowResize: function(e) {
        $timeout.cancel(resizeTimer);
        resizeTimer = $timeout(function() {
          $scope.programsDetailChart.chart.css({
            height: ($(window).height() - $scope.programsDetailChart.chart.offset().top) + 'px'
          });
        }, 10);
      }

    };


    $scope.programsDetailChart.init();
}]);